import React from 'react'

export default function Service() {
  return (
    <div>
        <h1>Service</h1>
    </div>
  )
}
